<svg width="25" height="27" viewBox="0 0 25 27" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M18.236 10.0645C18.236 14.8226 14.4618 18.629 9.86799 18.629C5.27423 18.629 1.5 14.8226 1.5 10.0645C1.5 5.30644 5.27423 1.5 9.86799 1.5C14.4618 1.5 18.236 5.30644 18.236 10.0645Z"
    stroke="#D5D9E3" stroke-width="3" />
  <path d="M16 18L23 25" stroke="#D5D9E3" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
</svg>